import Phaser from 'phaser';
import { createJusticeAnimations } from './justiceAnimations';

export function createAllAnimations(scene: Phaser.Scene): void {
  // Create Justice animations
  createJusticeAnimations(scene);

  // TODO: Add other animation factories here as we analyze more packs
  // e.g. createKimAnimations(scene);
}
